import type React from 'react';
import { memo } from 'react';
import { cn } from '@/lib/utils';
interface StockVideoProps extends React.SVGProps<SVGSVGElement> {}
const _StockVideo = (props: StockVideoProps) => <svg aria-hidden="true" fill="none" height="16" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg" {...props} className={cn('size-4', props.className)} data-sentry-element="svg" data-sentry-component="_StockVideo" data-sentry-source-file="StockVideo.tsx">
    <polygon points="6 3 20 12 6 21 6 3" data-sentry-element="polygon" data-sentry-source-file="StockVideo.tsx" />
  </svg>;
const StockVideo = memo(_StockVideo);
export const StockVideoWithIconTag = ({
  className
}: {
  className?: string;
}) => <i data-sentry-component="StockVideoWithIconTag" data-sentry-source-file="StockVideo.tsx">
    <StockVideo className={className} data-sentry-element="StockVideo" data-sentry-source-file="StockVideo.tsx" />
  </i>;
export default StockVideo;